import { useEffect, useState } from "react";

const sizes = {
    mobile: {
        from: 0,
    },
    tablet: {
        from: 768,
    },
    desktop: {
        from: 992,
    },
};

const useDeviceParams = () => {
    const [width, setWidth] = useState(0);
    useEffect(() => {
        const updateIsMobile = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", updateIsMobile);
        updateIsMobile();
        return () => window.removeEventListener("resize", updateIsMobile);
    }, []);
    return {
        isMobile: width < sizes.tablet.from,
        isTablet: width >= sizes.tablet.from && width < sizes.desktop.from,
        isDesktop: width >= sizes.desktop.from,
        type: width < sizes.tablet.from ? "mobile" : width >= sizes.desktop.from ? "desktop" : "tablet",
        isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream,
        isAndroid: /Android/.test(navigator.userAgent) && !(window as any).MSStream,
    };
};

export default useDeviceParams;
